import React from 'react';
import ReactDOM from 'react-dom';
import { APP_ROOT_ID, HEADER_BASE_CONFIG } from '../constants';
import { makePluginsRunner } from '../pluginsRunner';
import { getDeviceType, getValueForDevice } from '../utils';
import { App } from './App';
import { pluginsRegistry } from '../plugins-registry';

export const init = async ({ krakenConfig }) => {
  const { productConfig, content, locale, headerType, plugins, productSource, vertical, buildVertical } = krakenConfig;
  const queuedRenderers = window.WHCore.header.queuedRenderers ?? [];
  const headerRenderers = Array.isArray(queuedRenderers) ? [].concat(...queuedRenderers) : [];

  window.WHCore.header.queuedRenderers = [];

  const pluginsRunner = makePluginsRunner({
    productSource: getValueForDevice(productSource),
    plugins,
    productConfig,
    locale,
    deviceType: getDeviceType(),
    headerType,
    header: HEADER_BASE_CONFIG,
    headerRenderers,
    vertical,
    pluginsRegistry,
  });

  window.WHCore = window.WHCore || {};
  window.WHCore.header = window.WHCore.header || {};
  window.WHCore.header.addRenderers = pluginsRunner.getAddHeaderRenderers();

  pluginsRunner.beforeRender();

  ReactDOM.render(
    <App
      headerType={headerType}
      headerConfig={HEADER_BASE_CONFIG}
      content={content}
      headerRenderers={headerRenderers}
      jurisdiction={productConfig.jurisdiction}
      locale={locale}
      buildVertical={buildVertical}
    />,
    document.getElementById(APP_ROOT_ID)
  );

  pluginsRunner.afterRender();
};
